import type { IPaymentItem } from "@/data/model/Order";

import { Component } from "@/shared/elements/Component";

import { PaymentItem } from "@/portal/elements/transaction/TransactionItem";

export class PaymentItemsList extends Component {
    public readonly orderItems: IPaymentItem[];
    public readonly displayPrice: boolean;
    public readonly isCompact: boolean;

    constructor(orderItems: IPaymentItem[], displayPrice: boolean = false, isCompact: boolean = false) {
        super();
        this.orderItems = orderItems;
        this.displayPrice = displayPrice;
        this.isCompact = isCompact;

        this.$element = this.drawElement();
    }

    protected drawElement() {
        const orderItems = this.orderItems;

        // draw order item fields
        const $element = $('<div class="payment-items" />');

        if (this.isCompact) $element.addClass("compact");

        for (const orderItem of orderItems) {
            PaymentItem.render($element, orderItem, this.displayPrice);
        }

        return $element;
    }

    public static render(
        $appendToTarget: JQuery,
        paymentItems: IPaymentItem[],
        displayPrice: boolean = false,
        isCompact: boolean = false
    ): PaymentItemsList {
        const component = new PaymentItemsList(paymentItems, displayPrice, isCompact);
        component.renderTo($appendToTarget);

        return component;
    }
}
